export const USER_BLOCKED_PAGE_SLUG = 'user-blocked'
